import API from '@/api/api';

export class DepartmentModel {
    constructor() {
      if (DepartmentModel._instance) {
        return DepartmentModel._instance
      }

      DepartmentModel._instance = this;
    }

    async getDepartmentList() {
        if (this.departmentList && this.departmentList.length > 0) {
            return this.departmentList;
        }
        await API.getdDepartmentList().then((response) => {
            if(response.status) {
                if(!JSON.parse(response.request.response).error_msg) {
                    console.error('取得部門資料錯誤!');
                } else {
                    console.error(JSON.parse(response.request.response).error_msg);
                }
            } else {
                this.departmentList = response.result;
            }
        });
        return this.departmentList;
    }

    async getActualDeps() {
        if (this.actualDeps && this.actualDeps.length > 0) {
            return this.actualDeps;
        }
        await API.getActualDeps().then((response) => {
            if(response.status) {         
                if(!JSON.parse(response.request.response).error_msg) {
                    console.error('取得真實部門資料錯誤!');
                } else {
                    console.error(JSON.parse(response.request.response).error_msgs);
                }
            } else {
                this.actualDeps = response.result;
            }
        });
        return this.actualDeps
    }

    async reloadActualDeps() {
        await API.getActualDeps().then((response) => {
            if(response.status) {         
                if(!JSON.parse(response.request.response).error_msg) {
                    console.error('取得真實部門資料錯誤!');
                } else {
                    console.error(JSON.parse(response.request.response).error_msgs);
                }
            } else {
                if(this.actualDeps) {
                    this.actualDeps.splice(0);
                }
                this.actualDeps = response.result;
                if (this.actualDepsOptions && this.actualDepsOptions.length > 0) {
                    this.actualDepsOptions.splice(0);
                    this.actualDepsDict = null;
                }
            }
        });
        return this.actualDeps
    }

    async getActualDepsOptions() {
        if (this.actualDepsOptions && this.actualDepsOptions.length > 0) {
            return this.actualDepsOptions;
        }

        let departmentList = await this.getDepartmentList();
        let actualDeps = await this.getActualDeps();
        if (!this.actualDepsDict) {
            this.actualDepsDict = actualDeps.reduce((result, actualDeps) => {
                result[actualDeps.id] = {
                    value: actualDeps.id,
                    label: actualDeps.name
                };
                return result;
            },{});
        }

        this.actualDepsOptions = [];
        for (let i = 0; i < departmentList.length; i++) {
            const dep = departmentList[i];
            let option = { value: dep.id, label: dep.title };
            option.children = actualDeps
                .filter(dep => dep.depid === option.value)
                .map(dep => this.actualDepsDict[dep.id]);
            this.actualDepsOptions.push(option);
        }
        return this.actualDepsOptions;
    }

    async getOptions() {
        if (this.Options && this.Options.length > 0) {
            return this.Options;
        }

        let actualDeps = await this.getActualDeps();
        if (!this.actualDepsDict) {
            this.actualDepsDict = actualDeps.reduce((result, actualDeps) => {
                result[actualDeps.id] = {
                    value: actualDeps.id,
                    label: actualDeps.name
                };
                return result;
            },{});
        }

        this.Options = [];

        for (let i = 0; i < actualDeps.length; i++) {
            let dep = this.Options.find(x => x.value === actualDeps[i].dep.id);
            if(dep) {
                dep.children.push(this.actualDepsDict[actualDeps[i].id]);
            } else {
                let item = {
                    value: actualDeps[i].dep.id,
                    label: actualDeps[i].dep.title,
                    children: [this.actualDepsDict[actualDeps[i].id]],
                }
                this.Options.push(item);
            }
        }

        return this.Options;
    }

    async getDepName(id) {
        let actualDeps = await this.getActualDeps();
        if (!this.actualDepsDict) {
            this.actualDepsDict = actualDeps.reduce((result, actualDeps) => {
                result[actualDeps.id] = {
                    value: actualDeps.id,
                    label: actualDeps.name
                };
                return result;
            },{});
        }
        return this.actualDepsDict[id].label;
    }
}


// WEBPACK FOOTER //
// ./src/common/js/data.js